import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';
import { SpinnerSize, Stack } from '@fluentui/react';
import LoadingComponent from '../../../../../feedbacks/loading';
import Label from '../../../../../typography/label';
import GeneralService from '../../../../../../services/general';
import { IIncomeInvoiceResourceShortProps } from '../../../../../../props/finance/incomes/invoices/invoice';
import moment from 'moment';

type TotalIncomeInvoicePendingAmountCardProps = {
    style?: any;
    grow?: number | boolean | "inherit" | "initial" | "unset" | undefined;
    variant?: 'primary' | 'default';
    invoices?: IIncomeInvoiceResourceShortProps[];
}

const TotalIncomeInvoicePendingAmountCard: React.FC<TotalIncomeInvoicePendingAmountCardProps> = (props: TotalIncomeInvoicePendingAmountCardProps) => {
    const { banner } = useStore();
    const [overdueAmount, setOverdueAmount] = React.useState<number>();

    useEffect(() => {
        calculateOverdueAmount();
    }, [props.invoices]);

    const calculateOverdueAmount = () => {
        let totalAmount = 0;

        (props.invoices || []).forEach((invoice) => {
            if (Number(invoice.unpaid || '0') > 0 && moment(invoice.dueDate).isBefore(moment())) {
                totalAmount += Number(invoice.unpaid || '0');
            }
        });

        setOverdueAmount(totalAmount);
    }

    return <Stack grow={props.grow} tokens={{ childrenGap: 20 }} className={`${styles.card} ${styles.variant}`} style={props.style}>
        <Stack>
            <Label size={'small'}>Overdue amount</Label>
        </Stack>
        <Stack>
            {!props.invoices ? <LoadingComponent labelPosition='right' label={'Retrieving ...'} spinnerPosition={'baseline'} size={SpinnerSize.small} /> : null}
            {props.invoices ? <>
                <Label className={'color-yellow'} size={'large'}>Rp. {GeneralService.getNumberWithSeparator(overdueAmount + '')}</Label>
            </> : null}
        </Stack>
    </Stack>;
};

export default TotalIncomeInvoicePendingAmountCard;
